export default __webpack_public_path__ + "2941ffc95326a33f4b78a29c53d17829.png";